<template>
	<div class="home-page" :class="{ 'menu-open': menuOpen }">
		<!-- 顶部导航 -->
		<Header :showLogo="true" :theme="headerTheme" :fixed="true" :showBorder="isScrolled" :backgroundColor="headerBg"
			@menu-open="menuOpen = true" @menu-close="menuOpen = false" :iconColor="iconColor" />

		<!-- Hero Section -->
		<section class="hero-section" @click.prevent="onViewAllClick()"
			:style="{ backgroundImage: `url(${topBannerImage})` }">
			<div class="hero-content">
				<h2 class="hero-subtitle font-apercu-medium" style="cursor: pointer;">Discover Our Full Collection</h2>
				<h1 class="hero-title font-bespoke" style="cursor: pointer;">Essential for Your Wellbeing</h1>
			</div>
		</section>

		<!-- Collection Grid -->
		<section class="collection-grid">
			<div class="grid-item" v-for="item in collectionItems" :key="item.name">
				<div class="image-wrapper">
					<img :src="item.image" :alt="item.name" @click="goToBy('/product/index', item.name)">
				</div>
				<p class="item-name font-apercu-medium">{{ item.name }}</p>
			</div>
		</section>

		<!-- Project Banner -->
		<section class="project-banner" @click="goToProjects" :style="{ backgroundImage: `url(${projectBannerImage})` }"
         style="cursor: pointer;">
			<div class="banner-content">
				<h2 class="banner-subtitle font-apercu-medium">Discover Projects</h2>
				<h1 class="banner-title font-bespoke">You're Allowed to Dream</h1>
			</div>
		</section>

		<!-- Two Column Section -->
		<section class="two-column-section">
			<div class="column-item" @click="goToMaterials" style="cursor: pointer;">
				<div class="column-image-wrapper">
					<img :src="materialsImage" alt="denHolm Materials">
				</div>
				<div class="column-text-wrapper">
					<h3 class="column-title font-apercu-bold">denHolm Materials</h3>
					<p class="column-subtitle font-apercu-medium">Discover Our Exclusive Material Range</p>
				</div>
			</div>
			<div class="column-item" @click="goToStories" style="cursor: pointer;">
				<div class="column-image-wrapper">
					<img :src="storiesImage" alt="Stories">
				</div>
				<div class="column-text-wrapper">
					<h3 class="column-title font-apercu-bold">Stories</h3>
					<p class="column-subtitle font-apercu-medium">Discover Behind the Scenes Stories</p>
				</div>
			</div>
		</section>

		<Footer layout="about" :showDecoration="true" :showStudio="true" :showInstagram="true"
			style="margin-top: 116rem;" />

	</div>
</template>

<script>
	import homeBg from '../assets/home_bg.jpg'
	import Header from '../components/Header.vue'
	import Footer from '../components/Footer.vue'

	// 使用 require 导入图片，确保路径正确解析
	const HOME_DEFAULT = require('../assets/home_bg.jpg')

	const HERO_MAP = {
		// TABLE
		'collection-entry-table': require('../assets/Group 1-1.png'),
		'collection-console-table': require('../assets/Group 1-2.png'),
		'collection-coffee-table': require('../assets/Group 1-3.png'),
		'collection-side-table': require('../assets/Group 1-4.png'),

		// SEATING / ACCESSORIES
		'collection-chair': require('../assets/_DSC0544 2 3.png'),
		'collection-stool': require('../assets/_DSC0544 2 3-1.png'),
		'collection-planter': require('../assets/_DSC0544 2 4.png'),
		'collection-lighting': require('../assets/_DSC0544 2 3.png'),
		'collection-mirror': require('../assets/_DSC0544 2 3-1.png'),
		'collection-hardware': require('../assets/_DSC0544 2 4.png'),
		'collection-decor': require('../assets/_DSC0544 2 3.png'),

		// INFO
		'info-about-us': require('../assets/_DSC0544 2 4.png'),
		'info-founder': require('../assets/_DSC0544 2 3-1.png'),

		// PROJECTS
		'projects-all-projects': require('../assets/_DSC0544 2 3.png')
	}

	export default {
		name: 'Home',
		components: {
			Header,
			Footer
		},
		data() {
			return {
				menuOpen: false,
				isScrolled: false,
				iconColor: 'white',
				baseBg: HOME_DEFAULT,
				projectBannerImage: require('../assets/home/bg2.jpg'),
				topBannerImage: require('../assets/home_bg.jpg'),
				materialsImage: require('../assets/46830015 1.png'),
				collectionItems: [{
						name: 'Atelier',
						image: require('../assets/home/home-silder1.png')
					},
					{
						name: 'Product',
						image: require('../assets/home/home-silder2.png')
					},
					{
						name: 'Sunshine',
						image: require('../assets/home/home-silder3.png')
					},
					{
						name: 'denHolm United',
						image: require('../assets/home/home-silder4.png')
					}
				]
			}
		},
		computed: {
			storiesImage() {
				return require('../assets/Stories.jpg')
			},
			headerTheme() {
				this.iconColor = this.isScrolled ? 'black' : 'white'
				return this.isScrolled ? 'light' : 'dark'
			},
			headerBg() {
				return this.isScrolled ? '#ffffff' : 'transparent'
			}
		},
		methods: {
			goToProjects() {
			    this.$router.push({ name: 'Projects' })
			  },
			  goToMaterials() {
			    this.$router.push({ name: 'Materials' })
			  },
			  goToStories() {
			    this.$router.push({ name: 'Stories' })
			  },
			handleScroll(e) {
				let scrollTop = 0
				if (e && e.target && typeof e.target.scrollTop === 'number') {
					scrollTop = e.target.scrollTop
				} else {
					scrollTop = window.scrollY || document.documentElement.scrollTop || 0
				}
				this.isScrolled = scrollTop > 50
			},
			openMenu() {
				this.menuOpen = true
			},
			goToBy(path, item) {
				console.log(item)
				var CategoryID = 0
				if (item == 'Atelier') {
					CategoryID = 80
				}
				if (item == 'Product') {
					CategoryID = 81
				}
				if (item == 'Sunshine') {
					CategoryID = 82
				}
				if (item == 'denHolm United') {
					window.open('https://www.denholm-united.com', '_blank')
					return
				}
				this.$router.push({
					path: path,
					query: {
						CategoryID: 80
					}
				})
			},
			onViewAllClick() {
				this.$router.push({
					name: 'ProductIndex'
				})
			},
		},
		mounted() {
			// 监听 .home-page 元素的滚动事件，而不是 window
			const homePage = this.$el
			if (homePage) {
				homePage.addEventListener('scroll', this.handleScroll)
			}
		},
		beforeDestroy() {
			const homePage = this.$el
			if (homePage) {
				homePage.removeEventListener('scroll', this.handleScroll)
			}
			document.body.style.overflow = ''
		}
	}
</script>

<style scoped>
	.home-page {
		width: 100%;
		height: 100vh;
		overflow-y: auto;
		position: relative;
		background: #fff;
		/* 隐藏滚动条但保留滚动功能 */
		scrollbar-width: none;
		/* Firefox */
		-ms-overflow-style: none;
		/* IE 10+ */
	}

	/* 隐藏 Webkit 内核浏览器(Chrome/Safari)的滚动条 */
	.home-page::-webkit-scrollbar {
		display: none;
	}

	/* Hero Section */
	.hero-section {
		width: 100%;
		height: 816rem;
		margin-top: -123rem;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: center;
		padding-bottom: 61rem;
	}

	.hero-content {
		text-align: center;
		color: #fff;
	}

	.hero-subtitle {
		font-size: 16rem;
		margin-bottom: 15rem;
		font-weight: 500;
	}

	.hero-title {
		font-size: 30rem;
		font-weight: 400;
	}

	/* Collection Grid */
	.collection-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 16rem;
		padding: 48rem 31rem 96rem;
	}

	.grid-item {
		/* min-height: 424rem; */
		/* max-height: 424rem; */
		text-align: center;
	}

	.image-wrapper {
		width: 100%;
		/* height: 100%; */
		aspect-ratio: 3 / 4;
		background-color: #f5f5f5;
		margin-bottom: 20rem;
		overflow: hidden;
	}

	.image-wrapper img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		/* transition: transform 0.5s ease; */
		/* border: 1rem solid #000; */
	}

	.image-wrapper:hover img {
		/* transform: scale(1.05); */
		border: 1rem solid #000;
	}

	.item-name {
		font-size: 16rem;
		color: #000;
		font-weight: 500;
	}

	/* Project Banner */
	.project-banner {
		width: 100%;
		height: 1008rem;
		background-size: cover;
		background-position: center;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: center;
		padding-bottom: 69rem;
	}

	.banner-content {
		text-align: center;
		color: #fff;
	}

	.banner-subtitle {
		font-size: 16rem;
		margin-bottom: 15rem;
		font-weight: 500;
	}

	.banner-title {
		font-size: 30rem;
		font-weight: 400;
	}

	/* Two Column Section */
	.two-column-section {
		display: flex;
		padding: 47rem 39rem;
		gap: 20rem;
	}

	.column-item {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
	}

	.column-image-wrapper {
		width: 100%;
		aspect-ratio: 4/3;
		background-color: #f5f5f5;
		margin-bottom: 21rem;
		overflow: hidden;
	}

	.column-image-wrapper img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.column-title {
		font-size: 20rem;
		margin-bottom: 7rem;
		font-weight:500;
	}

	.column-subtitle {
		font-size: 16rem;
		color: #000;
		/* font-weight: 500; */
	}
	/* .column-title {
		font-size: 20rem;
		margin-bottom: 7rem;
	  font-family: 'Apercu-Bold', 'Helvetica Neue', 'Arial', sans-serif;
	  font-weight: 700; 
	}
	.column-subtitle {
	  font-family: 'Apercu-Medium', 'Helvetica Neue', 'Arial', sans-serif;
	  font-weight: 500;
	  font-size: 16rem;
	  color: #000;
	} */

	/* 当菜单打开时，背景图变暗 (Legacy style, might need adjustment) */
	.home-page.menu-open {
		/* background-color: rgba(0, 0, 0, 0.7); */
	}

	/* Responsive */
	@media (max-width: 768px) {

		.hero-title,
		.banner-title {
			font-size: 30rem;
		}

		.collection-grid {
			grid-template-columns: repeat(2, 1fr);
		}

		.two-column-section {
			flex-direction: column;
		}
	}

	@media (max-width: 480px) {
		.collection-grid {
			grid-template-columns: 1fr;
		}
	}
</style>